<span class="form-input-file">
  <p-fileupload 
    #fileUpload
    [chooseLabel]="('button.select-' + ext) | translate"
    [id]="id"
    [maxFileSize]="'1000000'"
    [mode]="'advanced'"
    [multiple]="false"
    [name]="label ? label : ('field.'+ field) | translate"
    [showUploadButton]="false"
    (onSelect)="onInput($event)"
    (onRemove)="onRemove()"
  >
    <ng-template #empty>
        <div>{{ 'drag-and-drop' | translate}}</div>
    </ng-template>
  </p-fileupload>
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
    [required]="formControl.errors?.['required']"
    [extension]="formControl.errors?.['extension']"></app-form-input-error>
</span>